export const FEATURE_EXAMPLE_NAME = 'example-name';

export const FEATURE_CMS_PAGE_CONTENT = 'cms-page-content';
export const FEATURE_HIRER_ADMIN_PRIMARY_CONTACT =
  'hirer-admin-primary-contact';
